import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Zap, Users, TrendingUp, Repeat, Mail } from 'lucide-react';
import { base44 } from '@/api/base44Client';

const BENEFITS = [
  { title: 'ENHANCE', icon: Zap, desc: 'Engage drivers and spectators with live-action views, key event data, and hotlap leaderboards with full telemetry.' },
  { title: 'MULTIPLY', icon: Users, desc: 'Add driver progression for regulars, live multi-venue racing, enhanced tournament management, championships & leagues.' },
  { title: 'ELEVATE', icon: TrendingUp, desc: 'Increase repeat business with automated telemetry comparisons and align with traditional motorsports via realworld analysis tooling.' },
  { title: 'RETAIN', icon: Repeat, desc: 'Fully automate membership sign-ups and subscription payment processing.' },
  { title: 'COMMUNICATE', icon: Mail, desc: 'Synchronise data with Mailchimp for GDPR compliant customer contact.' },
];

export default function DriverBenefits({ email }) {
  const [hasRigBooking, setHasRigBooking] = useState(null);

  useEffect(() => {
    if (!email) return;
    base44.entities.Booking.filter({ customer_email: email })
      .then((bookings) => setHasRigBooking(bookings.some((b) => b.rig_type)))
      .catch(() => setHasRigBooking(false));
  }, [email]);

  if (hasRigBooking === null || !hasRigBooking) return null;

  return (
    <section className="px-6 lg:px-10 py-10 max-w-4xl mx-auto">
      <div className="mb-8">
        <p className="text-primary text-xs font-bold tracking-widest mb-2">DRIVER BENEFITS</p>
        <h2 className="text-white font-black text-2xl md:text-3xl uppercase leading-tight">As A Motion Reality Driver</h2>
        <p className="text-white/40 text-sm mt-2 max-w-xl">
          You've experienced our rigs first-hand. Here's what's coming next for regular drivers.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {BENEFITS.map((b, i) => (
          <motion.div
            key={b.title}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.06 }}
            className={`bg-[#111115] border border-white/5 p-6 ${i === BENEFITS.length - 1 ? 'md:col-span-2' : ''}`}
          >
            <div className="flex items-center gap-3 mb-3">
              <div className="w-9 h-9 bg-primary/10 border border-primary/20 flex items-center justify-center">
                <b.icon className="w-4 h-4 text-primary" />
              </div>
              <h3 className="text-white font-bold text-sm tracking-wide">{b.title}</h3>
            </div>
            <p className="text-white/50 text-sm leading-relaxed">{b.desc}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}